<style scoped>
.input-setting-block .faucet-serial-number-block input {
    text-align: center;
    padding-left: 0;
}
</style>

<template>
<div class="col-12 row input-setting-block">
  <!-- <div class="offset-1 col-1 elips"></div>
  <div class="col-2 item-name">
    Уникальный код
  </div>
  <div class="col-4 faucet-serial-number-block">
    <input class="" v-bind:class="{fail: serial_fail}" v-model="serial_number" type="text" maxlength="14">
    </div>
    <div class="col-4 after-input-msg">
      <p v-if="serial_msg_text">{{serial_msg_text}}</p>
    </div>
    <div class="col-12 center-button-block">
      <a v-on:click="addFaucet" class="aquazor-btn">Добавить кран</a>
    </div> -->
    <div class="col-12">
        <h3 class="text-center">Список доступных вам кранов</h3>
    </div>
    <faucets-without-group-list-component></faucets-without-group-list-component>
</div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import faucets_block from './elements/faucets-without-group-list.vue'

export default {
  data() {
    return {
      serial_number: '',
      serial_fail: false,
      serial_msg_type: 'hidden',
      serial_msg_text: ''
    }
  },
  components: {
    'msg-component': msg,
    'faucets-without-group-list-component': faucets_block
  },
  watch: {
      serial_number: function (this_serial_number, old_serial_number) {
        if (this_serial_number != null && this_serial_number != old_serial_number) {
            var serial_number = this_serial_number.split("-").join("")
            serial_number = serial_number.toUpperCase()
            if (serial_number.length > 0) {
                this.serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
            }
        }
      }
  },
  methods: {
    addFaucet: function () {
      this.serial_msg_type = 'hidden'
      this.serial_fail = false
      this.serial_msg_text = ''
      if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_group', this.$route.params.id_group)
        post_data.set('device_number', this.serial_number)
        var vue_obj = this
        axios({
            method: 'POST',
            url: config.API_HOST + '/faucets/add_faucet',
            data: post_data
          })
          .then(function (response) {
            if (response.data.success) {
              vue_obj.$router.replace('/faucets-list/' + vue_obj.$route.params.id_group)
            }
          })
          .catch(function (error) {
            if (!!error.response.data.exception) {
              vue_obj.serial_fail = true
              vue_obj.serial_msg_type = 'alert'
              vue_obj.serial_msg_text = error.response.data.exception
              console.log(error.response.data)
            }
          })
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/add-faucet.vue